import React from "react";
import Page from "components/common_components/Page/Page";
import Button from "components/common_components/Button";

const ButtonPage = () => {
    return (
        <Page>
            <Button primary>Click me!</Button>
            <Button secondary>Click me!</Button>
        </Page>
    );
};

export default ButtonPage;
